import { Button } from "components/Button/Button";
import { Dialog } from "components/Dialog/Dialog";
import { DialogActionsBar } from "components/Dialog/DialogActionsBar";

import "./LogoutDialog.scss";

interface LogoutDialogProps {
  onLogoutNoClick: () => void;
  onLogoutYesClick: () => void;
  show: boolean;
}

const LogoutDialog = function render(props: LogoutDialogProps) {
  if (!props.show) {
    return null;
  }

  return (
    <Dialog title="Logout" onClose={props.onLogoutNoClick} className="logout-dialog">
      <p>Are you sure you want to logout?</p>
      <DialogActionsBar>
        <Button data-testid="cancel-logout" onClick={props.onLogoutNoClick}>
          Cancel
        </Button>
        <Button data-testid="confirm-logout" onClick={props.onLogoutYesClick} themeColor="primary">
          Logout
        </Button>
      </DialogActionsBar>
    </Dialog>
  );
};

export default LogoutDialog;
